Jelly.AJAX.Request = function(Parameters)
{
	// TODO: description
	// Parameters: Post_Parameters, On_Complete, ... // TODO
	
	var Debug = false && Jelly.Debug.Debug_Mode;
	
	if (Debug)
	{
		Jelly.Debug.Group("AJAX Request");
		Jelly.Debug.Log(Parameters);
	}

	// Pair POST parameters with "="...
	// TODO - old but didn't want to fuck with this
	if (Debug)
	{
		Jelly.Debug.Log("AJAX Parameters...");
		Jelly.Debug.Log(Parameters);
	}

	// Serialize post values to String.
	var Post_Values_String = Jelly.Utilities.Serialize({"Values": Parameters["Post_Variables"]});

	// TODO:should it be handled in Serialize by encoding Value_Keys? I think so...
	Post_Values_String = Post_Values_String.replace(new RegExp("[+]", "g"), "%2B");
	if (Debug)
	{
		Jelly.Debug.Log("Post_Values_String...");
		Jelly.Debug.Log(Post_Values_String);
	}
	
	$.post(
			Parameters.URL
		, Post_Values_String
	).done(function (Response_Data, Response_Status) { 
			if (Debug)
				Jelly.Debug.Group("AJAX State 4: Done");
			
			if (Response_Status == 200){
			}
			
			// Call On Complete Handler
			if (Parameters.On_Complete) { 
				if (Parameters.Original_Values) {
					Parameters.On_Complete(Response_Data, Parameters.Original_Values);
				}
				else { 
					Parameters.On_Complete(Response_Data);
				}
			}
			
			if (Debug)
				Jelly.Debug.End_Group("AJAX State 4: Done");
		}
	).fail(function(Request_Object){	
		if (Request_Object.readyState == 0) {
			
			// This is an iOS bug where it doesn't send requests at all if the processors are busy
			//alert("Failed");
			
			// If we've already tried all of our requests, throw an alert for Facebook browsers to get on Safari
			if (Parameters.Retry_Requests_Remaining == 0) {
				if (Jelly.Utilities.Detect_Feature("Is_Facebook"))
					alert ("We're having trouble with Facebook Browser. Please open this page in your normal browser for better results.");
			}
			else {
				// alert("Retrying");
				// Set default retry requests
				if (Parameters.Retry_Requests_Remaining === null)
					Parameters.Retry_Requests_Remaining = 10;
				
				// Retry 
				Parameters.Retry_Requests_Remaining--;
				Jelly.AJAX.Request(Parameters);
			}
			
		}
	});
	
	// TODO:...
	// HTTP_Request.setRequestHeader("X-Requested-With", "XMLHttpRequest");
	// HTTP_Request.setRequestHeader("Accept", "text/javascript, text/html, application/xml, text/xml, */*");
	// HTTP_Request.setRequestHeader("Content-type", "application/x-www-form-urlencoded; charset=UTF-8");
	
	if (Debug)
	{
		Jelly.Debug.End_Group("AJAX Request");
	}
};